import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-column pl-2 pr-2" }
const _hoisted_2 = { class: "mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "FARBY", -1)
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_link, { to: "/mod-stock/colors/0" }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimevueButton, {
              label: "Pridať farbu",
              severity: "success",
              icon: "pi pi-plus",
              text: "",
              raised: "",
              class: "uppercase"
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_DataTable, {
        scrollable: "",
        scrollHeight: `${this.vh - 290}px`,
        value: this.colors,
        stripedRows: "",
        "row-hover": "",
        selection: this.selectedColor,
        "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((this.selectedColor) = $event)),
        selectionMode: "single",
        metaKeySelection: false,
        onRowSelect: _cache[1] || (_cache[1] = ($event: any) => ($options.editColor(this.selectedColor.id))),
        tableStyle: "width: 100%",
        virtualScrollerOptions: { itemSize: 40 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            header: "",
            style: {"min-width":"5%"}
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", {
                class: "color-box",
                style: _normalizeStyle({ backgroundColor: slotProps.data.colorHash })
              }, null, 4)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "code",
            header: "Kód",
            style: {"min-width":"10%"}
          }),
          _createVNode(_component_Column, {
            field: "description",
            header: "Popis",
            style: {"min-width":"30%"}
          }),
          _createVNode(_component_Column, {
            field: "shade",
            header: "Odtieň",
            style: {"min-width":"10%"}
          }),
          _createVNode(_component_Column, { header: "Imitácia dreva" }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.imitation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "áno"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _withDirectives(_createVNode(_component_PrimevueButton, {
                type: "button",
                icon: "pi pi-pencil",
                onClick: ($event: any) => ($options.editColor(slotProps.data.id)),
                text: "",
                size: "small"
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  { value: 'Editácia farby' },
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_PrimevueButton, {
                type: "button",
                icon: "pi pi-trash",
                onClick: ($event: any) => ($options.deleteColor(slotProps.data.id)),
                text: "",
                severity: "danger",
                size: "small"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["scrollHeight", "value", "selection"])
    ]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}